import { render, staticRenderFns } from "./RemoveCouponFromPackageButton.vue?vue&type=template&id=2a45b726&scoped=true"
import script from "./RemoveCouponFromPackageButton.vue?vue&type=script&lang=js"
export * from "./RemoveCouponFromPackageButton.vue?vue&type=script&lang=js"
import style0 from "./RemoveCouponFromPackageButton.vue?vue&type=style&index=0&id=2a45b726&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a45b726",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a45b726')) {
      api.createRecord('2a45b726', component.options)
    } else {
      api.reload('2a45b726', component.options)
    }
    module.hot.accept("./RemoveCouponFromPackageButton.vue?vue&type=template&id=2a45b726&scoped=true", function () {
      api.rerender('2a45b726', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/coupon/package/modules/RemoveCouponFromPackageButton.vue"
export default component.exports